<div style="margin-bottom: .5rem" class="commission-input-container">
    <div class="commission-input-group" [formGroup]="form">
        <div class="group-name" [ngStyle]="{marginLeft: checkboxControlName ? '10px' : '0'}">
            <ng-container *ngIf="!checkboxControlName">{{fieldName}}</ng-container>
            <mat-checkbox *ngIf="checkboxControlName" [formControlName]=checkboxControlName>{{fieldName}}</mat-checkbox>
        </div>
        <div class="group-content">
            <ng-select
                *ngIf="units && (!checkboxControlName || (checkboxControlName && form.get(checkboxControlName).value))"
                [formControlName]=selectedUnit
                style="height: 100%; width: 160px; font-size: 16px; padding: 10px 0; margin-right: 10px;background-color: black;color: #DEDEDE;"
                [searchable]="false" [clearable]="false">
                <ng-option *ngFor="let u of units" [value]="u.value">{{u.name['en']}}</ng-option>
            </ng-select>
            <div fxLayout="row" fxLayoutAlign="start center">
                <ng-container
                    *ngIf="(!checkboxControlName || (checkboxControlName && form.get(checkboxControlName).value)) && selectedUnit">
                    <div *ngIf="((checkboxControlName && form.get(checkboxControlName).value) || !checkboxControlName) && form.get(selectedUnit).value === 1"
                        fxLayout="column" fxLayoutGap="4px" fxLayoutAlign="start start">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                            <input currencyMask (blur)="inputChange()" [formControlName]=formControlNameRate
                                [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}">
                            <div>%</div>
                        </div>
                        <div *ngIf="form.get(formControlNameRate).errors" class="group-error">
                            <ng-container *ngIf="form.get(formControlNameRate).errors.required">
                                This field is required
                            </ng-container>
                            <ng-container
                                *ngIf="form.get(formControlNameRate).errors.min || form.get(formControlNameRate).errors.max">
                                0 - 100 is allowed.
                            </ng-container>
                            <ng-container *ngIf="form.get(formControlNameRate).errors.pattern">
                                2 decimal places are allowed.
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="form.get(selectedUnit).value === 2 && (!checkboxControlName || (checkboxControlName && form.get(checkboxControlName).value))"
                        fxLayout="column" fxLayoutGap="4px" fxLayoutAlign="start start">
                        <div>
                            A$<input currencyMask style="margin-left: 5px;" [formControlName]=formControlNameFixed
                                [options]="{ prefix: '', thousands: ',', decimal: '.', precision: 2}">
                        </div>
                        <div *ngIf="form.get(formControlNameFixed).errors" class="group-error">
                            <ng-container *ngIf="form.get(formControlNameFixed).errors.required">
                                This field is required
                            </ng-container>
                            <ng-container
                                *ngIf="form.get(formControlNameFixed).errors.min || form.get(formControlNameFixed).errors.max">
                                0 - 99999999 is allowed
                            </ng-container>
                            <ng-container *ngIf="form.get(formControlNameFixed).errors.pattern">
                                2 decimal places are allowed.
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!selectedUnit && checkboxControlName && form.get(checkboxControlName).value">
                    <div fxLayout="column" fxLayoutGap="4px" fxLayoutAlign="start start">
                        <input currencyMask (blur)="inputChange()" [formControlName]=formControlNameFixed
                            [options]="{ prefix: 'A$ ', thousands: ',', decimal: '.', precision: 2}">
                        <div *ngIf="form.get(formControlNameFixed).errors" class="group-error">
                            <ng-container *ngIf="form.get(formControlNameFixed).errors.required">
                                This field is required.
                            </ng-container>
                            <ng-container
                                *ngIf="form.get(formControlNameFixed).errors.min || form.get(formControlNameFixed).errors.max">
                                0 - 99999999 is allowed.
                            </ng-container>
                            <ng-container *ngIf="form.get(formControlNameFixed).errors.pattern">
                                2 decimal places are allowed.
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
    <div *ngIf="children && checkboxControlName && form.get(checkboxControlName).value" [formGroup]="form">
        <div class="group-child" *ngFor="let child of children">
            <div class="child-name">{{child.childName}}</div>
            <div class="child-content">
                <div fxLayout="column" style="margin-right: 10px">
                    <mat-radio-group *ngIf="child.radioGroupControlName" [formControlName]=child.radioGroupControlName>
                        <mat-radio-button [value]=true>{{'yes'}}</mat-radio-button>
                        <mat-radio-button [value]=false>{{'no'}}</mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="form.get(child.radioGroupControlName).errors" class="child-error">
                        This field is required.
                    </div>
                </div>
                <div *ngIf="child.selectedChildUnit && form.get(child.radioGroupControlName).value" fxLayout="row"
                    fxLayoutGap="10px">
                    <ng-select
                        *ngIf="units && child.radioGroupControlName && form.get(child.radioGroupControlName).value"
                        [formControlName]=child.selectedChildUnit
                        style="height: 100%; width: 160px; font-size: 16px; padding: 10px 0; margin-right: 10px"
                        [searchable]="false" [clearable]="false">
                        <ng-option *ngFor="let u of units" [value]="u.value">{{u.name['en']}}</ng-option>
                    </ng-select>
                    <div>
                        <div *ngIf="form.get(child.selectedChildUnit).value === 1" fxLayout="column" fxLayoutGap="4px"
                            fxLayoutAlign="start start">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                                <input [formControlName]=child.childFormControlNameRate>
                                <div>%</div>
                            </div>
                            <div *ngIf="form.get(child.childFormControlNameRate).errors" class="child-error">
                                <ng-container *ngIf="form.get(child.childFormControlNameRate).errors.required">
                                    This field is required
                                </ng-container>
                                <ng-container
                                    *ngIf="form.get(child.childFormControlNameRate).errors.min || form.get(child.childFormControlNameRate).errors.max">
                                    0 - 100 is allowed.
                                </ng-container>
                                <ng-container *ngIf="form.get(child.childFormControlNameRate).errors.pattern">
                                    2 decimal places are allowed.
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="form.get(child.selectedChildUnit).value === 2" fxLayout="column" fxLayoutGap="4px"
                            fxLayoutAlign="start start">
                            <input currencyMask [formControlName]=child.childFormControlNameFixed
                                [options]="{ prefix: 'A$ ', thousands: ',', decimal: '.', precision: 2}">
                            <div *ngIf="form.get(child.childFormControlNameFixed).errors" class="child-error">
                                <ng-container *ngIf="form.get(child.childFormControlNameFixed).errors.required">
                                    This field is required.
                                </ng-container>
                                <ng-container
                                    *ngIf="form.get(child.childFormControlNameFixed).errors.min || form.get(child.childFormControlNameFixed).errors.max">
                                    0 - 99999999 is allowed.
                                </ng-container>
                                <ng-container *ngIf="form.get(child.childFormControlNameFixed).errors.pattern">
                                    2 decimal places are allowed.
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>